import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";

import { registerNavSection } from "./shell/navigation";

registerNavSection({ key: "engineering", spoke: "engineering", title: "Engineering", icon: PrecisionManufacturingIcon, order: 40, entries: [
  { label: "Items", to: "/app/engineering/items", permission: "engineering.item.view" },
  { label: "Engineering changes", to: "/app/engineering/changes", permission: "engineering.change.view" },
  { label: "Item classes", to: "/app/masterdata/item-classes", permission: "engineering.item_class.view" },
  { label: "Standard operations", to: "/app/masterdata/standard-operations", permission: "engineering.routing.view" },
  { label: "Tooling", to: "/app/masterdata/tooling", permission: "engineering.tooling.view" },
  { label: "Work instructions", to: "/app/masterdata/work-instructions", permission: "engineering.routing.view" },
] });
